// extracted by mini-css-extract-plugin
export default {"wrapper":"RecentImplantsPage_wrapper__vJIaT","header":"RecentImplantsPage_header__d0f+e","row":"RecentImplantsPage_row__Jss+9","editButton":"RecentImplantsPage_editButton__HiEbp"};